// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__jXXkp","question":"Question_question__3BXtl","description":"Question_description__3pbLI"};